import React, { Component } from "react";
import PropTypes from "prop-types";
import ContainerDimensions from "react-container-dimensions";
import { nest, sum, ascending, merge } from "d3";
import moment from "moment";
import { Box, Lead } from "rebass";
import {
  LineChart,
  Line,
  XAxis,
  YAxis,
  CartesianGrid,
  Tooltip,
  Legend
} from "recharts";

// import { dumyDataViews } from "./utils";

class ViewChart extends Component {
  constructor(props) {
    super(props);
    // const dataViews = this.getDataViews(dumyDataViews);
    const dataViews =
      props.data && props.data.length > 0
        ? this.getDataViews(props.data)
        : props.defaultData;

    this.state = {
      dataViews: dataViews
    };
  }
  componentWillReceiveProps(nextProps) {
    if (nextProps.data && nextProps.data.length > 0) {
      this.state = {
        dataViews: this.getDataViews(nextProps.data)
      };
    } else {
      this.state = {
        dataViews: nextProps.defaultData
      };
    }
  }

  getDataViews = data => {
    const newDataViews = merge([data, this.props.defaultData]);
    let dataViews = nest()
      .key(function(d) {
        return moment(d.date).format("YYYY-MM-DD");
      })
      .sortKeys(ascending)
      .rollup(function(view) {
        return sum(view, function(d) {
          return d.views;
        });
      })
      .entries(newDataViews)
      .map(function(group) {
        let merged = { date: group.key, views: group.value };
        return merged;
      });
    return dataViews;
  };
  render() {
    const { dataViews } = this.state;

    return (
      <Box w={[1]} p={[1]}>
        <Box w={[1]} p={[2]}>
          <Lead>Views</Lead>
        </Box>
        <ContainerDimensions>
          {({ width, height }) => {
            let mainWidth = width - 50;
            let mainHeight = mainWidth / 2;
            if (width < 600) {
              // mainWidth = 800;
              mainHeight = mainWidth / 1.8;
            }
            return (
              <LineChart
                width={mainWidth}
                height={mainHeight}
                data={dataViews}
                margin={{ top: 20, right: 20, left: 20, bottom: 20 }}
              >
                <XAxis dataKey="date" />
                <YAxis
                  label={{
                    value: "Views",
                    angle: -90,
                    position: "insideLeft"
                  }}
                />
                <CartesianGrid strokeDasharray="3 3" />
                <Tooltip />
                <Legend />
                <Line
                  type="monotone"
                  dataKey="views"
                  stroke="#8884d8"
                  activeDot={{ r: 8 }}
                />
              </LineChart>
            );
          }}
        </ContainerDimensions>
      </Box>
    );
  }
}

ViewChart.propTypes = {
  data: PropTypes.array,
  defaultData: PropTypes.array.isRequired
};

ViewChart.defaultProps = {
  data: [],
  defaultData: []
};

export default ViewChart;



// WEBPACK FOOTER //
// ./src/campaigns/chart/ViewChart.js